export const getDisplayValue = (value?: number | null): string => {
  if (value == null) return '';
  const strValue = (value * 100).toLocaleString('en', { maximumFractionDigits: 0 });
  return `${strValue}%`;
};
